import utility from '../store/utility';
import request from '../store/curl';
import media_utility from '../store/media_utility';
import attachment_file_preview from "../components/attachment_file_preview";
const Entities = require('html-entities').XmlEntities;
const entities = new Entities();

export default {
  name: 'message_format',
  props: ['msg', 'channel', 'reply_to_msg'],
  components: {
    attachment_file_preview
  },
  data: () => ({
    rich_message_data: {},
    text_message: '',
    is_rich_message: false,
    rich_msg_loading: false,
    messageFormatStyle: {},
    message: '',
    content_message_data: {},
    file_download_loader: false,
    attachmentFilePreviewShow: false,
    attachment_file_preview_data: {},
    message_format_content_width: '',
    reply_to_msg_data:{},
    user_contact_list: {}    
  }),
  computed: {
    userData() {
      return this.$store.getters.userData;
    },
    async getUserContactList() {
      return await this.$store.getters.getUserContactList;
    }
  },
  updated() {
  },
  async mounted() {
    this.user_contact_list = await this.getUserContactList;
    
    let width = 0;
    if (this.channel == 'receiver') {
      width = 90;
    }
    else {
      width = 40;
    }
    
    this.messageFormatStyle = {
      'max-width': (window.innerWidth - width) + 'px'
    }
    this.message_format_content_width = (window.innerWidth - width);

    if (this.reply_to_msg) {
      this.reply_to_msg_data = this.reply_to_msg;
    }

    this.messageFormat(this.msg);
  },
  methods: {
    /**
     * messageFormat
     */
    async messageFormat(msg) {
      if (!msg.message_type) {
        //Message Type Missing so set it to 10 (unpinned state)
        msg.message_type = '10';
      }

      this.message = entities.encode(msg.text_msg);
      if (this.message) {
        let urls = utility.detectUrlFromText(this.message);

        //Has Media itel
        if (msg.message_content_type && msg.message_content_type == 1 && msg.message_content_data) {
          this.content_message_data = msg.message_content_data;
          let msg_array = this.message.split(' ');
          let caption = '';
          if (msg_array && msg_array.length > 0) {
            this.message = entities.decode(msg_array[0]);
            msg_array[0] = '';
            caption = msg_array.join(' ').trim();
          }
          
          var captionTagStrArr = utility.getUserTags(caption);
          if (captionTagStrArr) {
            caption = await this.replaceUserIdMicro(caption, captionTagStrArr);
          }
          
          this.$set(this.content_message_data, 'url', this.message);          
          this.$set(this.content_message_data, 'caption', caption);

          let base64Image = await media_utility.getDownloadedFileBase64(this.content_message_data.file_name, this.content_message_data.file_type, this.content_message_data.file_mime_type);
          if (base64Image) {
            this.$set(this.content_message_data, 'base64Image', base64Image);
          }
          else{
            //For null - file does not exists so needs to be downloaded from url
            //Show image from firebase url if image not found in storage with real time chating(listner and sender) in this case file is downloading in background. its only availabe for given time in envronment variable time. after time expiry user have to click download button for showing image.
            var current_date = new Date(); // current date
            var msg_date = utility.moment(parseInt(msg.message_time)).toDate();
            var timeDiff = Math.abs(msg_date.getTime() - current_date.getTime());
            var timeDiffInSecond = Math.floor(timeDiff / 1000); // in second
            
            if(this.content_message_data.file_type == "image"){
              if(timeDiffInSecond <= process.env.VUE_APP_SHOW_IMAGE_IF_NO_FOUND_SECOND){
                //Now this image url will be displayed
                this.$set(this.content_message_data, 'base64Image', this.content_message_data.url);
              }
            }
            else{
              //When media message becomes old by 1hr or 1day or as defined, then we dont load from url. especially images. 
              //user needs to download the image if not done. images get dispayed from fs in base64 format 
              this.$set(this.content_message_data, 'base64Image', '');
            }
          }          
        }
        else {
          //check urls is not null
          if (urls) {
            //get first url and check url is valid
            // @ReviewWithAlok
            // this.message = entities.decode(urls[0]);

            if (utility.isValidUrl(this.message)) {
              this.is_rich_message = true;
              var post_data = new FormData();
              post_data.append("chat_user_id", this.userData.user_id);
              post_data.append("url", this.message);

              this.rich_msg_loading = true;
              request.curl(this, "link_preview", post_data, process.env.VUE_APP_MESH_DOMAIN)
                .then(response => {
                  this.rich_msg_loading = false;
                  if (response.resp_status) {
                    if (response.resp_data.title) {
                      this.rich_message_data = response.resp_data;
                    }
                    else {
                      this.rich_message_data = {};
                    }
                  }
                });
            }
            else {
              this.is_rich_message = false;
            }
          }
        }

        var tagStrArr = utility.getUserTags(this.message);
        if (tagStrArr) {
          this.message = await this.replaceUserIdMicro(this.message, tagStrArr);
        }

        this.text_message = utility.replaceUrlIntoLink(this.message).replace(/(\r\n|\n)/g, "<br/>");
      }
    },
    /**
     * replaceUserIdMicro 
     * User tag with user name by user id for mention user
     */
    async replaceUserIdMicro(message, tagStrArr){
      return utility.replaceUserIdMicro(message, tagStrArr, this.user_contact_list, true);
    },
    /**
     * bytesToSize
     */
    bytesToSize(bytes) {
      return media_utility.bytesToSize(bytes);
    },
    /**
      * msg_time
      */
    msg_time(timestamp) {
      return utility.get_message_datetime(timestamp, 'DD/MM/YYYY');
    },
    /**
     * file_download
     */
    async file_download(content_message_data) {
      if(content_message_data.base64Image){ 
        media_utility.displayLocalFile(content_message_data);
      }
      else{
        this.file_download_loader = true;
        let res = await media_utility.file_download(content_message_data);
        if (res) {
          this.file_download_loader = false;
          content_message_data.base64Image = content_message_data.url;
        }
      }
    },
    /**
     * cancel_download
     */
    cancel_download() {
      media_utility.cancel_download();
      this.file_download_loader = false;
    },
    /**
     * attachmentFilePreviewShowDialog
     */
    attachmentFilePreviewShowDialog(content_message_data) {
      this.attachment_file_preview_data = content_message_data;
      this.attachmentFilePreviewShow = true;
    }
  },
  watch: {
    /**
     * msg
     */
    msg: function (msg) {
      this.messageFormat(msg);
    },
    /**
     * reply_to_msg
     */
    reply_to_msg: function (msg) {
      if (msg) {
        this.reply_to_msg_data = msg;
      }
      else {
        this.reply_to_msg_data = '';
      }
    }
  }
}
